import * as React from "react";

function SvgFacebookCircle(props) {
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}><path d="M24 12.07C24 5.41 18.63 0 12 0S0 5.4 0 12.07C0 18.1 4.39 23.1 10.13 24v-8.44H7.08v-3.49h3.05V9.41c0-3.02 1.79-4.7 4.53-4.7 1.31 0 2.68.24 2.68.24v2.97h-1.5c-1.5 0-1.97.93-1.97 1.89v2.26h3.33l-.53 3.5h-2.8V24C19.61 23.1 24 18.1 24 12.07z" fill="#3579EA" /></svg>;
}

export default "//cdn.scentbird.com/assets/frontbird-site/images/facebook-circle_8f27d7.svg";
export { SvgFacebookCircle as ReactComponent };